module.exports = __webpack_public_path__ + "static/title_bg-d03ed42053e4e04a8ed97f0bab6f9b28.svg";